import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { Volume2, Leaf, IndianRupee, Wrench, Clock, Shield } from 'lucide-react';

export default function DGReplacementPage() {
  return (
    <SolutionPageTemplate
      slug="dg-replacement"
      title="DG Replacement with BESS"
      subtitle="Core Solution"
      description="Replace noisy, polluting diesel generators with clean, silent battery energy storage. Save 30–60% on fuel costs while eliminating emissions and maintenance headaches."
      heroImage="/images/voltide-battery-ev-charger.png"
      path="/solutions/dg-replacement"
      sectorLabel="general"
      useCaseParam="dg_replacement"
      benefits={[
        { icon: Volume2, title: 'Zero Noise', desc: 'Completely silent operation. No more complaints from neighbours or customers.' },
        { icon: Leaf, title: 'Zero Emissions', desc: 'No exhaust, no pollution. Meet ESG goals and sustainability targets.' },
        { icon: IndianRupee, title: '30–60% Cost Savings', desc: 'Eliminate diesel procurement, storage, and pilferage costs.' },
        { icon: Wrench, title: 'No Maintenance', desc: 'No oil changes, no filters, no engine overhauls. Fully managed service.' },
        { icon: Clock, title: 'Instant Start', desc: 'Millisecond switchover vs minutes for DG. No power interruption.' },
        { icon: Shield, title: '99.5% Uptime SLA', desc: 'Remote monitoring, proactive maintenance, and guaranteed availability.' },
      ]}
      howItWorks={[
        { title: 'Site Assessment', desc: 'We evaluate your current DG usage, power demand, and backup requirements to size the optimal BESS.' },
        { title: 'Deploy & Commission', desc: 'Containerised BESS arrives ready to use. Quick installation with minimal disruption to operations.' },
        { title: 'Operate & Monitor', desc: 'Fully managed operation with 24/7 remote monitoring. Predictable monthly cost, no surprises.' },
      ]}
      faqs={[
        { q: 'Can BESS fully replace my diesel generator?', a: 'Yes, for most commercial applications with backup requirements of 2–6 hours. Our BESS systems provide clean, instant power with the same reliability as DG sets.' },
        { q: 'What happens when the battery runs out?', a: 'Our systems are sized to cover your backup needs. For extended outages, the BESS can be paired with solar or grid charging to extend runtime significantly.' },
        { q: 'Is BESS more expensive than diesel?', a: 'On a per-kWh basis, BESS is 30–60% cheaper than diesel when you factor in fuel, maintenance, and downtime costs. Rental models eliminate upfront capex entirely.' },
        { q: 'How long does installation take?', a: 'Typical installation takes 2–5 days depending on site complexity. Our containerised systems arrive pre-configured and tested.' },
        { q: 'What about the noise and space requirements?', a: 'BESS operates silently and has a smaller footprint than most DG sets. A 500 kWh system fits in a standard 10-ft container.' },
      ]}
      productFilter={p => p.pcs_kw >= 125}
    />
  );
}
